import helper from '../helper'

const apiKeysEndpoint = 'api/v1/api-keys'

export const serviceApiKeys = {
  get: (token, params) => helper.get(apiKeysEndpoint, token, params),
  post: (token, data) => helper.post(apiKeysEndpoint, data, token),
  delete: (token, { apiKeyId }) => helper.delete(`${apiKeysEndpoint}/${apiKeyId}`, token)
}
